import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39207d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"150px"}
}
const _hoisted_2 = { class: "d-flex align-center ga-3" }
const _hoisted_3 = { class: "flex-grow-1 min-w-0" }
const _hoisted_4 = { class: "text-h6 font-weight-bold text-wrap" }
const _hoisted_5 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis text-wrap"
}
const _hoisted_6 = {
  key: 1,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_7 = { class: "d-flex flex-wrap ga-2 mt-3" }
const _hoisted_8 = { class: "text-subtitle-1 font-weight-bold mb-1" }
const _hoisted_9 = { class: "text-caption text-medium-emphasis" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold mb-1" }, "Cuenta", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Email", -1))
const _hoisted_13 = { class: "text-body-2 dato" }
const _hoisted_14 = { class: "text-caption text-medium-emphasis" }
const _hoisted_15 = { class: "px-4 pb-3" }
const _hoisted_16 = {
  key: 0,
  class: "px-4 pb-3"
}
const _hoisted_17 = { class: "text-caption text-medium-emphasis mb-0 mt-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold mb-1" }, "Notificaciones", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-medium-emphasis mb-0 mt-1" }, " Nuevos eventos, rondas, inscripciones, pagos, listas y partidas amistosas, por correo y en la app. Si los desactivas, solo te llegarán los correos de tu cuenta, como el de recuperar la contraseña. ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold mb-1" }, "Borrar la cuenta", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-medium-emphasis mb-2" }, " Borra tus datos personales. Tus resultados se quedan en los eventos como «Desconocido». ", -1))

import { computed, onMounted, ref } from "vue";
import { useAuth } from "@/composables/useAuth";
import { useToast } from "@/composables/useToast";
import { useBiometria } from "@/composables/useBiometria";
import { useUsuariosStore } from "@/store/usuarios";
import { UsuarioViewDTO } from "@/interfaces/Usuario";
import { FaccionDTO } from "@/interfaces/Faccion";
import { getFacciones } from "@/services/FaccionesService";
import { editarUsuario } from "@/services/UsuariosService";
import { fechaConocida } from "@/utils/Fecha";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import FormularioPerfil from "@/components/Perfil/FormularioPerfil.vue";
import ModalCambiarPass from "@/components/Perfil/ModalCambiarPass.vue";
import ModalBorrarCuenta from "@/components/Perfil/ModalBorrarCuenta.vue";
import { useRouter } from "vue-router";
import avatarPorDefecto from "@/assets/icons/perfil.png";

interface Dato {
  etiqueta: string;
  icono: string;
  valor?: string;
  enlace?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PerfilUsuarioView',
  setup(__props) {

const usuariosStore = useUsuariosStore();
const { getUser, logout } = useAuth();
const router = useRouter();
const { triggerToast } = useToast();
const biometria = useBiometria();
const nombreAcceso = ref("");
const accesoActivado = ref(false);

const desactivarAcceso = async () => {
  await biometria.desactivar();
  accesoActivado.value = false;
};

const isLoading = ref(true);
const editando = ref(false);
const cambiarPass = ref(false);
const borrarCuenta = ref(false);

// Ya no existe: fuera la sesión y a la pantalla de entrar
const alBorrarCuenta = () => {
  borrarCuenta.value = false;
  usuariosStore.usuario = {} as UsuarioViewDTO;
  void biometria.desactivar();
  logout();
  triggerToast("success", "Tu cuenta se ha borrado");
  router.push({ name: "inicio-sesion" });
};
const guardandoAvisos = ref(false);
const facciones = ref<FaccionDTO[]>([]);

// El del store: la barra de arriba pinta el mismo, así un avatar nuevo se ve en los dos sitios
const usuario = computed<UsuarioViewDTO | undefined>(() =>
  usuariosStore.usuario?.idUsuario ? usuariosStore.usuario : undefined
);

const nombreFaccion = computed(
  () => facciones.value.find(f => f.idFaccion === usuario.value?.idFaccion)?.nombreFaccion ?? ""
);

// "AAAA-MM-DD" a "15/03/1990" sin pasar por Date, que podría cambiar el día según la zona horaria
const fechaCorta = (fecha: string) => fecha.split("-").reverse().join("/");
const miembroDesde = computed(() => {
  const fecha = fechaConocida(usuario.value?.fechaRegistro);
  if (!fecha) return "";
  const [anio, mes] = fecha.split("-").map(Number);
  return new Date(anio, mes - 1, 1).toLocaleDateString("es-ES", { month: "long", year: "numeric" });
});

const secciones = computed<{ titulo: string; datos: Dato[] }[]>(() => {
  const u = usuario.value;
  if (!u) return [];
  const nacimiento = fechaConocida(u.fechaNacimiento);
  return [
    {
      titulo: "Datos personales",
      datos: [
        {
          etiqueta: "Nombre",
          icono: "mdi-account-outline",
          valor: [u.nombreUsuario, u.primerApellido, u.segundoApellido].filter(Boolean).join(" "),
        },
        {
          etiqueta: "Fecha de nacimiento",
          icono: "mdi-cake-variant-outline",
          valor: nacimiento ? fechaCorta(nacimiento) : "",
        },
        { etiqueta: "Teléfono", icono: "mdi-phone-outline", valor: u.telefono },
        { etiqueta: "Ciudad", icono: "mdi-map-marker-outline", valor: u.ciudad },
      ],
    },
    {
      titulo: "Como jugador",
      datos: [
        { etiqueta: "Nick", icono: "mdi-sword", valor: u.nick },
        { etiqueta: "Comunidad", icono: "mdi-shield-account-outline", valor: nombreFaccion.value },
        {
          etiqueta: "Nick en La Guerra del Anillo",
          icono: "mdi-link-variant",
          valor: u.nickLGDA,
          enlace: u.nickLGDA
            ? `https://www.laguerradelanillo.com/tu-perfil/${encodeURIComponent(u.nickLGDA)}`
            : undefined,
        },
      ],
    },
  ];
});

// Hasta que el back lo envíe, se dan por activados: es lo que había
const permiteNotificaciones = computed(() => usuario.value?.permiteNotificaciones ?? true);

const cambiarNotificaciones = async (valor: boolean | null) => {
  if (!usuario.value) return;
  const permite = !!valor;
  guardandoAvisos.value = true;
  try {
    await editarUsuario({ idUsuario: usuario.value.idUsuario, permiteNotificaciones: permite });
    usuariosStore.usuario = { ...usuariosStore.usuario, permiteNotificaciones: permite };
    triggerToast(
      "success",
      permite ? "Te avisaremos por correo" : "Ya no te enviaremos avisos por correo"
    );
  } catch (error) {
    console.error("Error al cambiar las notificaciones:", error);
    triggerToast("error", "No se pudo guardar el cambio");
  } finally {
    guardandoAvisos.value = false;
  }
};

const alGuardar = (cambios: Partial<UsuarioViewDTO>) => {
  usuariosStore.usuario = { ...usuariosStore.usuario, ...cambios };
  editando.value = false;
};

onMounted(async () => {
  nombreAcceso.value = await biometria.nombreDelAcceso();
  accesoActivado.value =
    !!nombreAcceso.value && (await biometria.cuentaActivada()) === getUser.value;
  try {
    const [, respuestaFacciones] = await Promise.all([
      usuariosStore.requestUsuario(getUser.value),
      getFacciones(),
    ]);
    facciones.value = respuestaFacciones.data;
  } catch (error) {
    console.error("Error al cargar el perfil:", error);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoadingGandalf)
        ]))
      : (usuario.value)
        ? (_openBlock(), _createBlock(_component_v_container, {
            key: 1,
            class: "perfil text-left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-3 mb-3",
                elevation: "2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_avatar, { size: "72" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: usuario.value.imagen || _unref(avatarPorDefecto),
                          alt: "Avatar",
                          cover: ""
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h1", _hoisted_4, _toDisplayString(usuario.value.nick), 1),
                      (nombreFaccion.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(nombreFaccion.value), 1))
                        : _createCommentVNode("", true),
                      (miembroDesde.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Miembro desde " + _toDisplayString(miembroDesde.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    (!editando.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          color: "primary",
                          variant: "tonal",
                          size: "small",
                          "prepend-icon": "mdi-pencil",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (editando.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Editar perfil ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      size: "small",
                      "prepend-icon": "mdi-chart-line",
                      to: `/detalle-jugador/${usuario.value.idUsuario}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Ver mi ficha de jugador ")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                _: 1
              }),
              (editando.value)
                ? (_openBlock(), _createBlock(FormularioPerfil, {
                    key: 0,
                    usuario: usuario.value,
                    facciones: facciones.value,
                    onGuardado: alGuardar,
                    onCancelar: _cache[1] || (_cache[1] = ($event: any) => (editando.value = false))
                  }, null, 8, ["usuario", "facciones"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secciones.value, (seccion) => {
                      return (_openBlock(), _createElementBlock("section", {
                        key: seccion.titulo
                      }, [
                        _createElementVNode("h2", _hoisted_8, _toDisplayString(seccion.titulo), 1),
                        _createVNode(_component_v_card, {
                          variant: "outlined",
                          class: "mb-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              density: "compact",
                              "bg-color": "transparent",
                              class: "py-1"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seccion.datos, (dato) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: dato.etiqueta,
                                    "prepend-icon": dato.icono
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_9, _toDisplayString(dato.etiqueta), 1),
                                      (dato.valor && dato.enlace)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: dato.enlace,
                                            target: "_blank",
                                            rel: "noopener",
                                            class: "text-body-2 text-primary dato"
                                          }, _toDisplayString(dato.valor), 9, _hoisted_10))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass(["text-body-2 dato", { 'text-medium-emphasis': !dato.valor }])
                                          }, _toDisplayString(dato.valor || "Sin indicar"), 3))
                                    ]),
                                    _: 2
                                  }, 1032, ["prepend-icon"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128)),
                    _hoisted_11,
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      class: "mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, {
                          density: "compact",
                          "bg-color": "transparent",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { "prepend-icon": "mdi-email-outline" }, {
                              default: _withCtx(() => [
                                _hoisted_12,
                                _createElementVNode("div", _hoisted_13, _toDisplayString(usuario.value.email), 1),
                                _createElementVNode("div", _hoisted_14, [
                                  _createTextVNode(" Es con el que entras. Si necesitas cambiarlo, escríbenos desde "),
                                  _createVNode(_component_router_link, { to: "/contacto" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Contacto")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(". ")
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_v_btn, {
                            variant: "tonal",
                            size: "small",
                            "prepend-icon": "mdi-lock-reset",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (cambiarPass.value = true))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Cambiar contraseña ")
                            ]),
                            _: 1
                          })
                        ]),
                        (accesoActivado.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_component_v_switch, {
                                "model-value": true,
                                color: "primary",
                                inset: "",
                                "hide-details": "",
                                density: "compact",
                                label: `Entrar con ${nombreAcceso.value}`,
                                "onUpdate:modelValue": desactivarAcceso
                              }, null, 8, ["label"]),
                              _createElementVNode("p", _hoisted_17, " Tu contraseña está cifrada en este dispositivo y solo se usa con " + _toDisplayString(nombreAcceso.value) + ". Al desactivarlo se borra. Se puede volver a activar al entrar con la contraseña. ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_18,
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      class: "pa-3 mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          "model-value": permiteNotificaciones.value,
                          color: "primary",
                          inset: "",
                          "hide-details": "",
                          density: "compact",
                          label: "Avisos",
                          loading: guardandoAvisos.value,
                          disabled: guardandoAvisos.value,
                          "onUpdate:modelValue": cambiarNotificaciones
                        }, null, 8, ["model-value", "loading", "disabled"]),
                        _hoisted_19
                      ]),
                      _: 1
                    }),
                    _hoisted_20,
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      class: "pa-3 mb-3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21,
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          color: "error",
                          size: "small",
                          class: "text-none px-0",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (borrarCuenta.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Borrar mi cuenta ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (cambiarPass.value)
      ? (_openBlock(), _createBlock(ModalCambiarPass, {
          key: 2,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (cambiarPass.value = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(ModalBorrarCuenta, {
      isVisible: borrarCuenta.value,
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => ((borrarCuenta).value = $event)),
      onBorrada: alBorrarCuenta
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})